// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"zE-z","smallCardRow":"AE-z","largeCardRow":"BE-z","productSearchRow":"CE-z","curatedRow":"DE-z"};